







import { defineComponent, PropType, computed } from '@vue/composition-api'

import Busy from './Busy.vue'

import { TShirtSize } from '@/lib/sizing'
import { Orientation } from '@/lib/positioning'

export default defineComponent({
  components: {
    Busy
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    waiting: {
      type: Boolean,
      default: false
    },
    label: {
      type: String
    },
    color: {
      type: String
    },
    size: {
      type: String as PropType<TShirtSize>,
      default: 'medium'
    },
    layout: {
      type: String as PropType<Orientation>,
      default: 'vertical'
    }
  },
  setup(props) {
    const classes = computed(() => ({
      'flex-row': props.layout === 'horizontal',
      'flex-col': props.layout === 'vertical'
    }))
    return {
      classes
    }
  }
})
